module.exports = __webpack_public_path__ + "img/logo4.223ab619.png";